<template>
	<b-modal centered title="Bienvenido a Kllaar" hide-footer hide-header v-model="modal">
		<div class="row">
			<div class="col-md-12 text-center p-5">
				<img src="@/assets/b_logo.png" height="50">
				<br><br>
				<h4 class="font-blue">¡Bienvenido a Kllaar.com!</h4>
				<div class="font-gray-dark">
					Ingresa y completa tu <router-link to="/perfil" class="font-orange">Perfil</router-link> de Empresa.
					<br><br>
					Publica tus <router-link to="/perfil/empleos" class="font-orange">Vacantes</router-link>,
					encuentra el talento que estás buscando, y mantente en la mira de nuestros aspirantes
					Desde hoy, crea un excelente historial y prestigio en la comunidad Kllaar.com
					<h3 class="font-weight-light my-4">¡Comienza Ya!</h3>
				</div>
				<b-button type="button" @click="onRead" class="b-orange col-md-12">Aceptar</b-button>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	name: 'SuccessEnterprise',
	data() {
		return {
			modal: true
		}
	},
	methods:{
		onRead(){
			this.modal = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/#auth/activation/SuccessEnterprise.vue